/**
 * supabase-fn-error — Extrait le vrai message d'erreur d'une FunctionsError
 * supabase-js. Par défaut l'erreur est générique ("non-2xx status code") ; si la
 * fonction Edge a renvoyé un body JSON `{ error }`, on le récupère via
 * `error.context.json()` pour afficher un toast utile (ex : message de cap 429).
 *
 * Partagé entre BriefActions et JulietteSignalsList (action « Préparer la relance »).
 */

import { FunctionsHttpError } from "@supabase/supabase-js";

export async function extractFunctionError(err: unknown): Promise<string> {
  if (err instanceof FunctionsHttpError) {
    try {
      const body = await err.context.json();
      if (body && typeof body === "object" && typeof body.error === "string") {
        return body.error;
      }
    } catch {
      // pas de JSON parsable, fallback
    }
  }
  return err instanceof Error ? err.message : String(err);
}
